export default {
    Get: {
        LIST_OF_ROOMS: 'getListOfRooms',
        CURRENT_ROOM: 'getCurrentRoom',
    },
    Set: {
        LIST_OF_ROOMS: 'setListOfRooms',
        CURRENT_ROOM: 'setCurrentRoom',
        ASSIGNVALUE_ROOM: 'setRoomValuePartial',
        ADD_TO_LIST: 'setRoomToList',
        ROOM_INDEXES: 'setRoomIndexes'
    }
};